var _g, _polyline, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalStorageTempControl = function SvgPSignalStorageTempControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349,401.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S354.8,401.6,349,401.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,381.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S343.5,381.1,349,381.1 M349,380.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S355.1,380.1,349,380.1L349,380.1z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 391.1,
    x2: 328.1,
    y2: 391.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3,389h-1.8v4.9h-1V389h-1.8v-0.8h4.5L351.3,389L351.3,389z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "349.1,380.1 349.1,237.2 349.1,237.2 304.1,237.2 304.1,237.1 304.1,55.1 342.1,55.1 342.1,46.1",
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349,361.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S354.8,361.6,349,361.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,341.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S343.5,341.1,349,341.1 M349,340.1c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S355.1,340.1,349,340.1L349,340.1z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 338,
    y1: 351.1,
    x2: 328.1,
    y2: 351.1,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3,349h-1.8v4.9h-1V349h-1.8v-0.8h4.5L351.3,349L351.3,349z"
  }))));
};
export default SvgPSignalStorageTempControl;